// extracted by mini-css-extract-plugin
export default {"loading":"Augment_loading__QQDEj"};